import type { Idea } from './api.ts';
import * as wording from './wording.ts';

/**
 * An idea from a pasted ideas document is seeded with its whole section —
 * pages of script — where a typed idea is one line. The batch page and the
 * one-by-one review list it by one line and fold the section away.
 */

/** Whether the seed is more than a line: a section of an ideas document. */
export function isSection(idea: Idea): boolean {
  return idea.seed.includes('\n');
}

/** The one line an idea is listed by: the line typed, or the title its document gave a section. */
export function seedLine(idea: Idea): string {
  if (!isSection(idea)) return idea.seed;
  return idea.sourceTitle ?? idea.seed.split('\n')[0] ?? '';
}

/** A document idea's section as written, folded away until asked for. */
export function IdeaSection({ seed, open = false }: { readonly seed: string; readonly open?: boolean }) {
  return (
    <details className="idea-section" open={open}>
      <summary>{wording.SHOW_SECTION}</summary>
      <pre>{seed}</pre>
    </details>
  );
}
